// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"4f351b2476d16e72d09c","453":"eff432290d8f2bcf8ae4"}[chunkId] + ".js";
};